import React, { useState, useEffect } from 'react'

import { useSelector, useDispatch } from 'react-redux'

import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import Card from '@material-ui/core/Card'

import Button from '@material-ui/core/Button'
import Fab from '@material-ui/core/Fab'
import Tooltip from '@material-ui/core/Tooltip'

import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import TextField from '@material-ui/core/TextField'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import InputBase from '@material-ui/core/InputBase'
import Accordion from '@material-ui/core/Accordion'
import AccordionSummary from '@material-ui/core/AccordionSummary'
import AccordionDetails from '@material-ui/core/AccordionDetails'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableBody from '@material-ui/core/TableBody'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import Table from '@material-ui/core/Table'

import { ThemeProvider } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Fade from '@material-ui/core/Fade'

import SearchIcon from '@material-ui/icons/Search'
import DeleteIcon from '@material-ui/icons/Delete'
import AddIcon from '@material-ui/icons/Add'
import DoneIcon from '@material-ui/icons/Done'
import CloseIcon from '@material-ui/icons/Close'
import InfoIcon from '@material-ui/icons/Info'
import IconButton from '@material-ui/core/IconButton'
import InputAdornment from '@material-ui/core/InputAdornment'

// import BottomNavigation from '@material-ui/core/BottomNavigation'

import { getSearchResults, createNewWord, getWordVault, getWordDetails } from '../../../../redux/actions'

import { NotificationToast, BaseToast } from '../../tools/Toast'
import { ConfirmToast } from '../../tools'

import { SliderTheme } from '../../../../utils'
import { isEqual } from 'lodash'

const baseForm = {
  wordID: '',
  phrase: '',
  wordDefinition: '',
  embedded: 0,
  excluded: 0,
  autoIgnore: 0,
  severity: 1,
  categoryID: '',
  language: 'en-us',
  keyboard: 1,
  application: 1,
  exclusions: []
}

/**
 * Returns word vault editor form
 */
const WordVaultNew = ({
  onBackTrack, onSaveBackTrack, selectedKey, setVaultForm,
  StyledSwitch, StyledCheckBox, CustomSlider, useStyles
}) => {
  const dispatch = useDispatch()
  const classes = useStyles()

  const marks = [
    { value: 20, label: '' },
    { value: 40, label: '' },
    { value: 60, label: '' },
    { value: 80, label: '' },
    { value: 100, label: '' }
  ]

  const categories = useSelector(state => state.words.categories)
  const unitWordVault = useSelector(state => state.words.wordVault)

  const [adding, setAdding] = useState(false)
  const [term, setTerm] = useState('')
  const [placement, setPlacement] = useState('ANY')
  const placements = ['BEFORE', 'AFTER', 'ANY']

  const [categoriesInfo, setCategoriesInfo] = useState([{
    categoryID: 0,
    categoryName: ''
  }])

  const copyInputValues = {
    id: 'outlined-helperText',
    label: 'Search',
    variant: 'outlined',
    autoComplete: 'off',
    helperText: 'Enter a Word to copy its settings.'
  }

  const [copyText, setCopyText] = useState(null)
  const [phraseSearched, setPhraseSearched] = useState(false)
  const [phraseInput, setPhraseInput] = useState('')
  const [inputValues, setInputValues] = useState(copyInputValues)

  const onCopyTextChange = (prop) => {
    const newText = prop.toUpperCase()
    setCopyText(newText)
  }

  const [form, setForm] = useState(baseForm)

  // sets categories
  useEffect(() => {
    if (categories) {
      const mappedCategories = []
      categories.forEach(category => {
        mappedCategories.push(category)
      })
      setCategoriesInfo(mappedCategories)
    }
  }, [categories])

  const onChange = (prop) => e => {
    e.preventDefault()
    if (prop === 'phrase') {
      setPhraseInput(e.target.value)
    }
    setForm({ ...form, [prop]: e.target.value })
  }

  // If the form has not been reset, but the search input has been deleted then reset the form
  useEffect(() => {
    if (!phraseInput.length && !isEqual(form, baseForm)) {
      setForm(baseForm)
    }
  }, [phraseInput, form])

  const handleDoneException = () => {
    if (term === '') {
      NotificationToast(false, 'Exception must have a term!', true)
    } else {
      const tempExceptions = [...form.exclusions]
      const newExpRendered = {
        exclusionPhrase: term.toUpperCase(),
        excludeBefore: placement === 'BEFORE' ? 1 : 0,
        excludeAfter: placement === 'AFTER' ? 1 : 0,
        excludeAny: placement === 'ANY' ? 1 : 0
      }
      tempExceptions.push(newExpRendered)

      setForm({ ...form, exclusions: tempExceptions })
      setAdding(false)
      setTerm('')
      setPlacement('ANY')
    }
  }

  const handleExpDelete = (exception) => {
    // const { exclusionID } = exception
    // if (exclusionID) {
    //   const tempExpDelete = [...deleteExceptions]
    //   tempExpDelete.push({ exclusionID })
    //   setDeleteExceptions(tempExpDelete)
    //   const expIndex = exceptions.findIndex((exp) => {
    //     return exp === exception
    //   })
    //   if (expIndex !== -1) {
    //     const tempExceptions = [...exceptions]
    //     tempExceptions.splice(expIndex, 1)
    //     setExceptions(tempExceptions)
    //   }
    // } else {
    const expIndex = form.exclusions.findIndex((exp) => {
      return exp === exception
    })
    if (expIndex !== -1) {
      const tempExceptions = [...form.exclusions]
      tempExceptions.splice(expIndex, 1)
      setForm({ ...form, exclusions: tempExceptions })
    }

    // const newExpIndex = newExceptions.findIndex((exp) => {
    //   return exp === exception
    // })

    // if (newExpIndex !== -1) {
    //   const tempNewExceptions = [...newExceptions]
    //   tempNewExceptions.splice(newExpIndex, 1)
    //   setNewExceptions(tempNewExceptions)
    // }
    // }
  }

  const handleDiscardException = () => {
    setTerm('')
    setPlacement('ANY')
    setAdding(false)
  }

  const handleAddException = () => {
    setAdding(true)
  }

  const toggleAutoIgnore = () => {
    const newForm = { ...form }
    newForm.autoIgnore = !newForm.autoIgnore
    setForm(newForm)
  }

  const toggleEmbeddedPhrase = () => {
    const newForm = { ...form }
    newForm.embedded = !newForm.embedded
    setForm(newForm)
  }

  const togglePhrase = () => {
    const newForm = { ...form }
    newForm.excluded = !newForm.excluded
    setForm(newForm)
  }

  const toggleKeyboard = () => {
    if (form.application === false || 0) {
      BaseToast('info', 'Phrase must have at least one source selected.')
    } else {
      const newForm = { ...form }
      newForm.keyboard = !newForm.keyboard
      setForm(newForm)
    }
  }

  const toggleApplication = () => {
    if (form.keyboard === false || 0) {
      BaseToast('info', 'Phrase must have at least one source selected.')
    } else {
      const newForm = { ...form }
      newForm.application = !newForm.application
      setForm(newForm)
    }
  }

  const handleSliderChange = (e, newVal) => {
    setForm({
      ...form,
      severity: newVal
    })
  }

  const handleKeySlider = (e, newVal) => {
    setForm({
      ...form,
      severity: Math.ceil(newVal / 2)
    })
  }

  const setLanguage = (e) => {
    const selectedLanguage = e.target.value
    const newForm = Object.assign({}, form)
    newForm.language = selectedLanguage
    setForm(newForm)
  }

  const setCategoryID = (e) => {
    const selectedID = e.target.value
    const newForm = Object.assign({}, form)
    newForm.categoryID = selectedID
    setForm(newForm)
  }

  const handleSearch = async () => {
    const unitID = selectedKey
    const upperCasePhrase = form?.phrase.toUpperCase()
    const searchText = copyText || upperCasePhrase
    const failFunc = copyText ? fireCopyNotFound : fireNotFound
    if (!copyText && !phraseInput.match(/^[^.\s]/)) {
      NotificationToast(true, 'Phrase cannot contain spaces at the beginning of the line')
      return false
    }

    setForm({ ...form, phrase: upperCasePhrase })
    setPhraseSearched(true)
    dispatch(getSearchResults(unitID, searchText, fireFound, failFunc))
  }

  // Check the returned wordID to see if it's already in the units word vault after search
  const fireFound = async (data) => {
    // Word vault list for selected unit
    const vaultList = unitWordVault.wordVault
    // Check through word vault list using wordID
    const customCheck = vaultList.find(word => word.wordID === data?.wordID)

    let newForm = {
      wordID: copyText ? form?.wordID : data?.wordID,
      phrase: copyText ? form?.phrase : data?.phrase,
      wordDefinition: data?.wordDefinition || '',
      embedded: data?.embedded || 0,
      excluded: data?.excluded || 0,
      autoIgnore: data?.autoIgnore || 0,
      severity: data?.severity || 1,
      categoryID: data?.categoryID || '',
      language: data?.language || 'en-us',
      keyboard: 1,
      application: 1,
      exclusions: data?.exclusions || []
    }

    if (!copyText) {
      // If it finds a match, display an alert letting user know it's in that units vault already
      if (customCheck) {
        setCopyText(null)
        setPhraseSearched(false)

        const vaultCheck = await ConfirmToast({ msg: 'This word is already in your custom vault.', txt: 'Would you like to edit it?' })
        // Get word details, reset search results, clear state, and take user to edit vault form if they confirm
        if (vaultCheck) {
          // NOTE ON 3/4/24: noticed while fixing bug involving the overuse of dispatches and redux, this arguably is also an overuse of a dispatch.
          // it is outside the scope of the current ticket, but I believe this form can be moved to the parent component and shared between new and edit, allowing the reuse of the form without needing to store it in redux
          dispatch(getWordDetails(selectedKey, data?.wordID))
          setVaultForm('edit')
        } else {
          newForm = { ...baseForm }
        }
      } else {
        BaseToast('info', 'This word already exists.', 'Add it to your custom vault to manage it.')
      }
    }

    if (copyText) {
      setInputValues({
        ...inputValues,
        helperText: 'Successfully Applied Settings'
      })
    }

    setForm(newForm)
  }

  const fireNotFound = () => {
    NotificationToast(false, 'This word does not exist already.')
  }

  const fireCopyNotFound = () => {
    setInputValues({
      ...inputValues,
      helperText: 'No Results Found'
    })
  }

  const submitForm = () => {
    const unitID = selectedKey
    if (adding) {
      NotificationToast(false, 'Save new exceptions!', true)
    } else {
      const info = {
        categoryID: form.categoryID,
        phrase: form.phrase,
        severity: form.severity,
        wordDefinition: form.wordDefinition,
        embedded: form.embedded ? 1 : 0,
        excluded: form.excluded ? 1 : 0,
        autoIgnore: form.autoIgnore ? 1 : 0,
        language: form.language,
        keyboard: form.keyboard ? 1 : 0,
        application: form.application ? 1 : 0,
        exclusions: [...form.exclusions]
      }

      dispatch(createNewWord(unitID, info, fireSuccess, fireFailure))
    }
  }

  const fireSuccess = () => {
    NotificationToast(false, 'Word created successfully!')
    dispatch(getWordVault(selectedKey))
    setForm(baseForm)
    onSaveBackTrack()
  }

  const fireFailure = () => {
    NotificationToast(true, 'Failed to create word.')
    setForm(baseForm)
  }

  const handleBack = () => {
    onBackTrack()
    setForm(baseForm)
  }

  const isEnabled = form.phrase && form.categoryID && form.severity && form.language

  return (
    <>
      <Paper elevation={2} className={classes.editPaper}>
        <Grid container direction='column' justify='center' className='w-100 mx-auto'>
          <Grid container item s={8} alignContent='center'>
            <Typography component='h6' className='mt-3 ml-3 px-3 mb-1 font-weight-bold' variant='h6'>Create New Word</Typography>
          </Grid>
          <Grid item container direction='row' justify='flex-start' spacing={3} className='w-100 mx-auto mt-2 mb-1 px-3'>
            <Grid item xs={9}>
              <div className={classes.search}>
                <div className={classes.searchIcon}>
                  <Fab
                    className={classes.searchBtn}
                    size='small'
                    onClick={handleSearch}
                  >
                    <SearchIcon />
                  </Fab>
                </div>
                <InputBase
                  placeholder='Search Phrase'
                  classes={{
                    root: classes.inputRoot,
                    input: classes.inputInput
                  }}
                  inputProps={{ 'aria-label': 'search' }}
                  onChange={onChange('phrase')}
                  value={form.phrase}
                  onBlur={handleSearch}
                />
              </div>
            </Grid>

            <Grid item xs={2} container alignContent='center'>
              <Typography
                variant='body1'
                component='label'
                className='font-weight-bold'
              >
                Phrase
              </Typography>
              <Typography variant='caption' component='label'>Required *</Typography>
            </Grid>
          </Grid>
          <Grid container item s={8} className='justify-content-start'>
            <Accordion
              className='mb-1 w-75'
              classes={{ disabled: classes.copySettingsBar }}
              style={{ textTransform: 'none', marginLeft: '29px' }}
              disabled={!phraseSearched || !phraseInput === '' || !phraseInput.match(/^[^.\s]/)}
            >
              <AccordionSummary
                className='w-100'
                classes={{ content: classes.accorSummary, root: classes.accorSummRoot }}
                expandIcon={<ExpandMoreIcon />}
                aria-controls='panel1bh-content'
                id='panel1bh-header'
              >
                <Typography className={classes.heading}>Copy Settings?</Typography>
                <Typography className={classes.secondaryHeading}>Apply settings of an existing word.</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <TextField
                  id={inputValues.id}
                  size='small'
                  autoComplete={inputValues.autoComplete}
                  label={inputValues.label}
                  helperText={inputValues.helperText}
                  variant={inputValues.variant}
                  onChange={(e) => onCopyTextChange(e.target.value)}
                  disabled={!phraseSearched || !phraseInput === '' || !phraseInput.match(/^[^.\s]/)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='end'>
                        <IconButton
                          aria-label='toggle password visibility'
                          onClick={handleSearch}
                          edge='end'
                        >
                          <SearchIcon />
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                />
              </AccordionDetails>
            </Accordion>
          </Grid>
          <Typography style={{ fontSize: 10, textTransform: 'none' }} className='mb-3 t-3 ml-3 px-3 text-muted'>Not Required</Typography>
          <Grid item container direction='row' justify='flex-start' spacing={3} className='w-100 mx-auto px-3'>
            <Grid item xs={9}>
              <FormControl className='w-100'>
                <InputLabel className='pl-3 pt-1 pb-1'>Category</InputLabel>
                <Select
                  onChange={(e) => { e.preventDefault(); setCategoryID(e) }}
                  variant='outlined'
                  value={form.categoryID}
                >
                  {categoriesInfo.map((category) => {
                    const { categoryID, categoryName } = category
                    return (
                      <MenuItem value={categoryID} key={`category-${categoryID}`}>
                        {categoryName}
                      </MenuItem>
                    )
                  })}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={3} container alignContent='center' justify='flex-start'>
              <Typography
                variant='body1'
                component='label'
                className='font-weight-bold'
              >
                Category
              </Typography>
              <Typography variant='caption' component='label'>Required *</Typography>
            </Grid>
          </Grid>

          <Grid item container direction='row' justify='flex-start' spacing={3} className='w-100 mx-auto my-2 px-3'>
            <Grid item xs={9}>
              <FormControl className='w-100'>
                <InputLabel className='pl-3 pt-1 pb-1'>Language</InputLabel>
                <Select
                  onChange={(e) => { e.preventDefault(); setLanguage(e) }}
                  variant='outlined'
                  value={form.language}
                >
                  <MenuItem value='en-us'>
                    English
                  </MenuItem>
                  <MenuItem value='es-es'>
                    Spanish
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={3} container alignContent='center' justify='flex-start'>
              <Typography
                variant='body1'
                component='label'
                className='font-weight-bold'
              >
                Language
              </Typography>
              <Typography variant='caption' component='label'>Required *</Typography>
            </Grid>
          </Grid>

          <Grid item container direction='row' justify='flex-start' spacing={3} className='w-100 mx-auto px-3'>
            <Grid item xs={9}>
              <FormControl className='w-100'>
                <TextField
                  // error={error}
                  placeholder='Definition...'
                  multiline
                  rows={3}
                  variant='outlined'
                  value={form.wordDefinition ? form.wordDefinition : ''}
                  // helperText='You must add a definition.'
                  onChange={onChange('wordDefinition')}
                />
              </FormControl>
            </Grid>

            <Grid item xs={3} container alignContent='center' justify='flex-start'>
              <Typography
                variant='body1'
                component='label'
                className='font-weight-bold'
              >
                Definition
              </Typography>
            </Grid>
          </Grid>

          <ThemeProvider theme={SliderTheme(form.severity)}>

            <Grid item container direction='row' justify='flex-start' spacing={3} className='w-100 mx-auto mt-5 mb-1 px-4'>
              <Grid item xs={9}>
                <CustomSlider
                  value={parseInt(form.severity, 10)}
                  onChange={handleSliderChange}
                  valueLabelDisplay='on'
                  aria-labelledby='app-severity-slider'
                  min={1}
                  max={100}
                  marks={marks}
                />
              </Grid>

              <Grid item xs={3} container justify='flex-start'>
                <Typography
                  variant='body1'
                  component='label'
                  className='font-weight-bold'
                >
                  Application Severity
                </Typography>
                <Typography variant='caption' component='label'>Required *</Typography>
              </Grid>
            </Grid>

            <Grid item container direction='row' justify='flex-start' spacing={3} className='w-100 mx-auto my-2 px-4'>
              <Grid item xs={9}>
                <ThemeProvider theme={SliderTheme((form.severity * 2) > 100 ? 100 : parseInt(form.severity * 2, 10))}>
                  <Tooltip
                    title={<Typography className='p-2'><InfoIcon /> Keyboard Severity maxed out</Typography>}
                    open={(form.severity * 2) > 100}
                    // onClose={() => setOpenInfo(false)}
                    placement='left'
                    TransitionComponent={Fade}
                    TransitionProps={{ timeout: 600 }}
                    arrow
                  >
                    <CustomSlider
                      value={(form.severity * 2) > 100 ? 100 : parseInt(form.severity * 2, 10)}
                      onChange={handleKeySlider}
                      valueLabelDisplay='on'
                      aria-labelledby='key-severity-slider'
                      min={1}
                      max={100}
                      marks={marks}
                    />
                  </Tooltip>
                </ThemeProvider>
              </Grid>

              <Grid item xs={3} container justify='flex-start'>
                <Typography
                  variant='body1'
                  component='label'
                  className='font-weight-bold text-wrap'
                >
                  Keyboard Severity
                </Typography>
                <Typography variant='caption' component='label'>Required *</Typography>
              </Grid>
            </Grid>

          </ThemeProvider>

          <Grid item container direction='row' justify='space-around' spacing={3} className='w-100 mt-1 mx-auto px-3'>
            <Grid item xs={4} container justify='center' direction='column'>
              <Grid item container justify='center'>
                <Typography
                  variant='body1'
                  component='label'
                  className='font-weight-bold'
                >
                  Phrase Enabled
                </Typography>
              </Grid>

              <Grid item container justify='center'>
                <FormControlLabel
                  label={!form.excluded ? 'Enabled' : 'Disabled'}
                  control={
                    <StyledSwitch
                      checked={!form.excluded}
                      onClick={togglePhrase}
                    />
                  }
                  labelPlacement='end'
                />
              </Grid>
            </Grid>

            <Grid item xs={4} container justify='center' direction='column'>
              <Grid item container justify='center'>
                <Typography
                  variant='body1'
                  component='label'
                  className='font-weight-bold'
                >
                  Auto 'Not A Problem'
                </Typography>
              </Grid>
              <Grid item container justify='center'>
                <FormControlLabel
                  label={form.autoIgnore ? 'Enabled' : 'Disabled'}
                  control={
                    <StyledSwitch
                      checked={!!form.autoIgnore}
                      onClick={toggleAutoIgnore}
                    />
                  }
                  labelPlacement='end'
                />
              </Grid>
            </Grid>

            {/* <Grid item xs={4} container justify='center' direction='column'>
              <Grid item container justify='center'>
                <Typography
                  variant='body1'
                  component='label'
                  className='font-weight-bold'
                >
                  Email Report
                </Typography>
              </Grid>
              <Grid item container justify='center'>
                <FormControlLabel
                  label={emailReport ? 'Enabled' : 'Disabled'}
                  control={
                    <StyledSwitch
                      checked={emailReport}
                      onClick={(e) => { e.preventDefault(); setEmailReport(!emailReport) }}
                    />
                  }
                  labelPlacement='end'
                />
              </Grid>
            </Grid> */}
          </Grid>

          <Grid item container direction='row' justify='flex-start' spacing={3} className='w-100 mx-auto px-3'>
            <Grid item xs={6} container justify='center' direction='column' alignItems='center'>
              <Grid item container justify='center' className='mt-auto'>
                <Typography
                  variant='body1'
                  component='label'
                  className='font-weight-bold'
                >
                  Detect Embedded
                </Typography>
              </Grid>

              <Grid item container justify='center'>
                <FormControlLabel
                  label={form.embedded ? 'Enabled' : 'Disabled'}
                  control={
                    <StyledSwitch
                      checked={!!form.embedded}
                      onClick={toggleEmbeddedPhrase}
                    />
                  }
                  labelPlacement='end'
                />
              </Grid>
            </Grid>

            <Grid item xs={6} container justify='center' direction='column'>
              <Grid item container justify='center' direction='row'>
                <FormControlLabel
                  value='Keyboard'
                  control={
                    <StyledCheckBox
                      checked={!!form.keyboard}
                      onChange={() => toggleKeyboard(!form.keyboard)}
                    />
                  }
                  label={<span className='font-weight-bold'>Keyboard</span>}
                  labelPlacement='start'
                  className='m-0 font-weight-bold'
                />
              </Grid>

              <Grid item container justify='center' direction='row'>
                <FormControlLabel
                  value='Application'
                  control={
                    <StyledCheckBox
                      checked={!!form.application}
                      onChange={() => toggleApplication(!form.application)}
                    />
                  }
                  label={<span className='font-weight-bold'>Application</span>}
                  labelPlacement='start'
                  className='m-0 font-weight-bold'
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid container item direction='row' justify='flex-start' spacing={3} className='w-100 mx-auto my-2 px-3'>
            <Grid item xs={9}>
              <Card>
                <TableContainer>
                  <Table stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell align='center' className={classes.tableHeader}>
                          Term
                        </TableCell>
                        <TableCell align='center' className={classes.tableHeader}>
                          Placement
                        </TableCell>
                        <TableCell colSpan={1} className={classes.tableHeader} />
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {
                        form.exclusions.length !== 0
                          ? form.exclusions.map((exception, id) => {
                            const after = exception.excludeAfter
                            const before = exception.excludeBefore
                            const any = exception.excludeAny
                            return (
                              <TableRow key={`exception-${id}`}>
                                <TableCell align='center'>
                                  {exception.exclusionPhrase}
                                </TableCell>
                                <TableCell align='center'>
                                  {after === 1 ? 'After' : before === 1 ? 'Before' : any === 1 ? 'Any' : 'N/A'}
                                </TableCell>
                                <TableCell align='center'>
                                  <Fab size='small' className={classes.deleteExp} onClick={() => handleExpDelete(exception)}>
                                    <DeleteIcon />
                                  </Fab>
                                </TableCell>
                              </TableRow>
                            )
                          })
                          : (
                            <TableRow>
                              <TableCell colSpan={3} align='center'>
                                <Typography className='font-weight-bold'>N/A</Typography>
                              </TableCell>
                            </TableRow>)
                      }
                      {
                        adding
                          ? (
                            <TableRow>
                              <TableCell colSpan={1}>
                                <TextField
                                  value={term}
                                  onChange={(e) => setTerm(e.target.value)}
                                  variant='standard'
                                  className='w-100'
                                />
                              </TableCell>

                              <TableCell colSpan={1}>
                                <Select
                                  value={placement}
                                  onChange={(e) => setPlacement(e.target.value)}
                                  className='w-100'
                                >
                                  {placements.map((type, index) => (
                                    <MenuItem value={type} key={`placement-${index}`}>
                                      {type}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </TableCell>

                              <TableCell colSpan={1}>
                                <Fab size='small' color='primary' onClick={handleDoneException} className='mb-2'>
                                  <DoneIcon />
                                </Fab>
                                <Fab size='small' className={classes.discardBtn} onClick={handleDiscardException}>
                                  <CloseIcon />
                                </Fab>
                              </TableCell>
                            </TableRow>)
                          : (
                            <TableRow>
                              <TableCell colSpan={3} align='center' padding='none' className='py-2'>
                                <Fab size='small' className={classes.addBtn} onClick={handleAddException}>
                                  <AddIcon />
                                </Fab>
                              </TableCell>
                            </TableRow>)
                      }
                    </TableBody>
                  </Table>
                </TableContainer>
              </Card>
            </Grid>

            <Grid item xs={3} container justify='flex-start' direction='row' alignContent='center'>
              <Typography
                variant='body1'
                component='label'
                className='font-weight-bold'
              >
                Exceptions
              </Typography>
            </Grid>
          </Grid>

        </Grid>

      </Paper>
      <Grid container>
        <nav className='nav p-2 shadow sticky-nav' style={{ backgroundColor: '#FAFAFA', borderBottomLeftRadius: '4px', borderBottomRightRadius: '4px' }}>
          <Grid item xs={12} container>
            <Grid item xs={6} container>
              <Button
                variant='contained'
                className={classes.backBtn}
                onClick={(e) => { e.preventDefault(); handleBack() }}
                style={{ marginLeft: '1rem' }}
              >
                Back
              </Button>
            </Grid>

            <Grid item xs={6} container justify='flex-end'>
              <Button
                variant='contained'
                className={classes.saveBtn}
                onClick={(e) => { e.preventDefault(); submitForm() }}
                disabled={!isEnabled}
              >
                Save
              </Button>
            </Grid>
          </Grid>
        </nav>
      </Grid>
      {/* <Grid style={{ backgroundColor: '#E9E9E9', opacity: '.9', position: 'sticky' }} container item direction='row' justify='flex-start' spacing={3} className='mx-auto my-2 px-3'>
        <Grid item xs={12} container>
          <Grid item xs={6} container>
            <Button variant='contained' className={classes.backBtn} onClick={(e) => { e.preventDefault(); handleBack() }}>
              Back
            </Button>
          </Grid>

          <Grid item xs={6} container justify='flex-end'>
            <Button
              variant='contained'
              className={classes.saveBtn}
              onClick={(e) => { e.preventDefault(); submitForm() }}
              disabled={!isEnabled}
            >
              Save
            </Button>
          </Grid>
        </Grid>
      </Grid> */}
    </>
  )
}

export default WordVaultNew
